<template>
  <SalesRegisterTableCard :is-empty="! rows.length" :is-loaded="isLoaded">
    <table class="table register-table">
      <thead>
      <tr>
        <th class="text-center">SL</th>
        <th v-for="column in columns" :key="column.key" :class="{ num: isNumeric(column) }">{{ column.label }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, i) in rows" :key="i">
        <td class="text-center">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
        <td v-for="column in columns" :key="column.key" :class="{ num: isNumeric(column) }">{{ formatCell(row, column) }}</td>
      </tr>
      </tbody>
      <tfoot v-if="isLastPage">
      <tr>
        <td :colspan="textColumnCount + 1" class="register-total-label">Total</td>
        <td v-for="column in numericColumns" :key="column.key" class="num">{{ formatTotal(totalValue, column) }}</td>
      </tr>
      </tfoot>
    </table>
  </SalesRegisterTableCard>
</template>

<script setup>
import { computed } from 'vue'
import SalesRegisterTableCard from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterTableCard.vue'
import purchaseRegisterColumns from '@/services/utils/purchaseRegisterColumns'

const props = defineProps({
  tab: {
    type: String,
    required: true
  },
  rows: {
    type: Array,
    default: () => []
  },
  currentPage: {
    type: Number,
    default: 1
  },
  lastPage: {
    type: Number,
    default: 1
  },
  perPage: {
    type: Number,
    default: 20
  },
  totalValue: {
    type: Object,
    default: () => ({})
  },
  isLoaded: {
    type: Boolean,
    default: true
  }
})

const { getColumns, isNumeric, formatCell, formatTotal } = purchaseRegisterColumns()

const columns = computed(() => getColumns(props.tab))

const numericColumns = computed(() => columns.value.filter(column => isNumeric(column)))

const textColumnCount = computed(() => columns.value.length - numericColumns.value.length)

const isLastPage = computed(() => {
  if (! props.rows.length) return false
  return props.currentPage === props.lastPage
})
</script>
